<template>
    <div class="calendar__mcontrols">
        <button class="calendar__mbutton calendar__prev r-button" type="button" @click="prev()" :disabled="prevShow">
            <span class="screen-reader">предыдущий месяц</span>
        </button>
        <div class="calendar__mlist">
            <div class="calendar__mvisible">
                <span class="calendar__month">{{ title }}</span>
            </div>
        </div>
        <button class="calendar__mbutton calendar__next r-button" type="button" @click="next()">
            <span class="screen-reader">следующий месяц</span>
        </button>
    </div>
</template>

<script>
	import {mapState, mapGetters, mapMutations} from 'vuex';

	import dayjs from 'dayjs';

    export default {
    	name: 'CalendarControls',
        computed: {
			...mapState([
				'startDate',
			]),
			...mapGetters([
				'dates',
			]),
			prevShow() {
				return this.startDate.isBefore(dayjs());
			},
    		title() {
				let title = [];
				let year = null;

				this.dates.forEach((value) => {
					let month = dayjs(value).format('MMMM');
					year = dayjs(value).format('YYYY');

					if (title.indexOf(month) < 0) {
						title.push(month);
					}
				});

				return title.join(' — ') + ' ' + year;
            }
        },
        methods: {
			...mapMutations([
				'setStartDate',
			]),
			next() {
				this.setStartDate(this.startDate.add(1, 'week'));
			},
			prev() {
				this.setStartDate(this.startDate.subtract(1, 'week'));
			}
        }
    }
</script>

